import Roles from '@/auth/roles';
import ClubForm from './club-form';
import ClubList from './club-list';
import ClubHistoryFull from './club-history/club-history-full/club-history-full';
import ClubHistorySingle from './club-history/club-history-single/club-history-single';
import ClubShow from './club-show';
import ClubImportcsv from './club-import-csv';

const roles = Roles.values;

export default [
  {
    name: 'clubList',
    path: 'club',
    component: ClubList,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.activityViewer.id,
        roles.entityViewer.id,
        roles.entityEditor.id,
        roles.clubViewer.id,
        roles.clubEditor.id,
        roles.clubManager.id
      ]
    },
    children: [
      {
        name: 'clubImportCsv',
        path: 'importCsv',
        components:  {
          clubImport: ClubImportcsv
        }
      }]
  },
  {
    name: 'clubNew',
    path: 'club/new',
    component: ClubForm,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.entityEditor.id,
        roles.clubEditor.id
      ]
    }
  },
  {
    name: 'clubEdit',
    path: 'club/:id/edit',
    component: ClubForm,
    props: true,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.entityEditor.id,
        roles.clubEditor.id
      ]
    }
  },
  {
    name: 'clubHistorySingle',
    path: 'club/:id/history',
    component: ClubHistorySingle,
    props: true,
    meta: {
      auth: true,
      roles: [roles.owner.id, roles.activityViewer.id]
    }
  },
  {
    name: 'clubHistoryFull',
    path: 'club/history',
    component: ClubHistoryFull,
    meta: {
      auth: true,
      roles: [roles.owner.id, roles.activityViewer.id]
    }
  },
  {
    name: 'clubShow',
    path: 'club/:id',
    component: ClubShow,
    props: true,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.activityViewer.id,
        roles.entityViewer.id,
        roles.entityEditor.id,
        roles.clubViewer.id,
        roles.clubEditor.id,
        roles.clubManager.id
      ]
    }
  }
];



// WEBPACK FOOTER //
// ./src/entities/club/club-routes.js